import React from "react";

import $ from "jquery";

import ReactDOM from "react-dom";

import _ from "underscore";

import "sparks/invoca_app";
import "sparks/invoca_sync";
import "sparks/controls";
import "sparks/modal_dialog";

import Toast from "shared/toast";

import AudioPlayerRenderer from "shared/browser_audio_player/renderer";

import Backdraft from "backdraft-app/src/backdraft";
import App from "backdraft-app/src/app";
import NotificationDropdown from "./notification_dropdown/components/notification_dropdown";
import { Provider } from 'react-redux';
import configureStore from './notification_dropdown/stores/configure_store';
import { fetchNotifications, receivePushNotification } from './notification_dropdown/actions/creators';
import PushNotificationHandler from './notification_dropdown/push_notification_handler';

class HeaderApp extends App {
  constructor() {
    super(["InvocaApp", "InvocaSync", "Controls", "ModalDialog"]);
  }

  activate(config) {
    this.config = config;
    // eslint-disable-next-line no-unused-vars
    var indexView = new this.Views.Index({ el: $("#header") });
    this.renderNotificationDropdown();
  }

  renderNotificationDropdown() {
    const notificationDropdownMount = document.querySelector('[data-mount="notification_dropdown"]');
    if (notificationDropdownMount != null) {
      const store = configureStore(this.config.urlConfig);
      try {
        ReactDOM.render(
          <Provider store={store}>
            <NotificationDropdown />
          </Provider>,
          notificationDropdownMount
        );
        store.dispatch(fetchNotifications());
      } catch (err) {
        console.error(err);
      }
      const handler = new PushNotificationHandler(this.config);
      handler.subscribeToEvent('new-push-notification', this._onReceivePushNotification(store));
    }
  }

  _onReceivePushNotification(store) {
    return (data) => {
      this._notificationToast(data.notification);
      store.dispatch(receivePushNotification(data.notification));
    };
  }

  _notificationToast(notification) {
    const toastMessage = {
      title: "New Notification",
      message: notification.message,
      sticky: true
    };
    const sendToast = { 'fail': Toast.error, 'warning': Toast.warning, 'in_progress': Toast.warning, 'success': Toast.success };
    const toastType = _.includes(Object.keys(sendToast), notification.status) ? notification.status : 'success';
    sendToast[toastType](toastMessage);
  }

  initAudioPlayer() {
    if (!this.audioPlayerRenderer) {
      this.audioPlayerRenderer = new AudioPlayerRenderer();
      this.audioPlayerRenderer.renderPlayer();
    }
  }

  renderAudioPlayButtons() {
    var self = this;
    this.initAudioPlayer();
    $('.js-audio-play-button').each(function() {
      var container = $(this);
      self.renderRecordingButton(container, container.data("recordingName"), container.data("recordingTitle"), container.data("recordingUrl"), container.data("autostart"));
    });
  }

  renderRecordingButton(container, recordId, recordTitle, recordingUrl, autostart) {
    this.initAudioPlayer();
    this.audioPlayerRenderer.renderRecordingButton(container, recordId, recordTitle, recordingUrl, autostart);
  }
}

const app = new HeaderApp();
export default Backdraft.app("Header", app);
